import { render, staticRenderFns } from "./OzBackButton.vue?vue&type=template&id=35f26012&"
import script from "./OzBackButton.vue?vue&type=script&lang=ts&"
export * from "./OzBackButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports